module.exports = __webpack_public_path__ + "static/media/Military-Nurse_1.137074fc.jpg";